/**
 * 🚀 Dynamic Components (Dyn)
 */
global.dyn = function(target) {
    if (!target) target = $('body');

    // ⏳ Gestion des comptes à rebours (.dyn.dyn--countdown)
    target.find('.dyn.dyn--countdown').each(function () {
        const $el = $(this);

        // Éviter la double initialisation
        if ($el.data('dyn-initialized')) return;
        $el.data('dyn-initialized', true);

        const dateEnd = $el.data('countdown');
        const dateStart = $el.data('date_start');

        if (!dateEnd) return;

        const pad = (n) => n < 10 ? '0' + n : n;
        const daysName = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'];

        /**
         * Met à jour le texte de l'élément avec le temps restant
         */
        const tick = () => {
            const timeInfo = dateDist(dateEnd, dateStart);

            if (timeInfo.distance > 0 && timeInfo.days >= 1) {
                const end = new Date(dateEnd);
                let msg = '';
                if (timeInfo.days < 7) {
                    msg = daysName[end.getDay()] + ' à ' + end.getHours() + 'h' + pad(end.getMinutes());
                } else {
                    msg = pad(end.getDate()) + '/' + pad(end.getMonth() + 1) + '/' + end.getFullYear() + ' à ' + end.getHours() + 'h' + pad(end.getMinutes());
                }
                $el.text(msg);
            } else {
                $el.text(timeInfo.launchMsg);
            }
        };

        // Démarrage immédiat et boucle toutes les secondes
        tick();
        const timer = setInterval(tick, 1000);
        $el.data('dyn-timer', timer);
    });
};

// Compatibilité avec l'ancien nom si besoin
global.dynCountdown = global.dyn;

// Initialisation automatique au chargement du document
$(function() {
    global.dyn($(document));
});
